const getMallTemplate = async ({ params, api }) => {
  return await api(`mallTemplate/${params.id}`)
    .then((res) => {
      return Promise.resolve({ data: res });
    })
};

export default getMallTemplate;
